<script>
    import Icono from "./Icono.svelte";
    import {createEventDispatcher} from 'svelte';

    const dispatcher = createEventDispatcher();

    export let id;
    export let label;
    export let value;
    export let valido = true;
    export let mensajeDeError = "";
    export let iconos = [];
    export let icono = false;
    export let disabled = false;

    let touched = false;

    const activo = (value, icono) => value === icono;

    const cambiaIcono = icono => () => dispatcher('input', icono);
</script>

<style>
    .campo {
        display: flex;
        border: 2px solid var(--bordes);
        border-radius: 3px 3px 0 0;
    }

    .icono {
        flex: 0 0 auto;
        background: var(--bordes);
        display: flex;
        color: var(--negro);
        padding: .25rem;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .invalid {
        border-color: var(--acentos);
    }

    .iconos {
        padding: calc(var(--padding-global) / 2);
    }

    .iconos-icono {
        background: var(--acentos);
        border-radius: var(--radio-global);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: .25rem .33rem;
        font-size: .8em;
        margin: calc(var(--padding-global) / 2);
    }

    .iconos-icono.activo {
        background: var(--verde);
    }

    .invalid .icono {
        background: var(--acentos);
    }

    .error-message {
        color: red;
        margin: 0.25rem 0;
    }
</style>

<div class="form-control">
    <label for={id}>{label}</label>
    <div class="campo" class:disabled class:invalid="{!valido && touched}">
        {#if icono}
            <div class="icono">
                <i class="material-icons">{icono}</i>
            </div>
        {/if}

        <div class="iconos">
            {#each iconos as imagen}
                <button class="iconos-icono" class:activo={activo(value, imagen)} on:click|preventDefault={cambiaIcono(imagen)} type="button">
                    <Icono svg={imagen} externo tamano={30} />
                </button>
            {/each}
        </div>
    </div>
    {#if mensajeDeError && !valido && touched}
        <p class="error-message">{mensajeDeError}</p>
    {/if}
</div>
